module.exports = __webpack_public_path__ + "static/don38-5c36a304b3151ca5eca0321fa0ce09cf.jpg";